import HttpClient from '../../HttpClient/NewApi';

export default {
    create(createSalesOrderRequest) {
        return HttpClient.post(`/api/v1/sales-orders`, createSalesOrderRequest);
    }
}

export class CreateSalesOrderRequest
{
    constructor(
        price, // Цена
        volumeId, //Идентификатор объема фермера
        cultureId, // Идентификатор культуры
        locationId, // Идентификатор геопозиции
        volume, // Объем
        quality, // Качество
    ) {
        this.darpoleyVolumeId = volumeId;
        this.price = price;
        this.locationId = locationId;
        this.grainId = cultureId;
        this.volume = volume;
        this.quality = quality;
    }
}


// WEBPACK FOOTER //
// ./apiClient/SalesOrder/Create/index.js